// src/components/Layout.jsx
import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { PropellerMultitag } from './PropellerMultitag';
import { TinyAdsScript } from './TinyAdsScript';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-950 to-black text-white">
      <Header />
      {/* <PropellerMultitag /> */}
      <main className="pt-16 md:pt-20 lg:pt-24">  {/* ← this solves the overlap forever */}
        {children}
      </main>
      <TinyAdsScript />
      <Footer />
    </div>
  );
}